export interface IBevarFilters {
  sortColumn: string | null
  sortOrder: string | null
}

export enum ActivityDeadlinesSortColumnEnum {
  title = 'tittel',
  responsible = 'ansvarligUtforelse',
  frequency = 'repetisjon',
  nextDeadline = 'frist',
}

export enum BudgetSortColumnEnum {
  year = 'key',
  cost = 'costInclVAT',
}

export enum MeasuresSortColumnEnum {
  description = 'lccJobName',
  area = 'areaName',
  performed = 'nextLccJobExecution',
  cost = 'costInclVAT',
}

export enum SortOrderEnum {
  Asc = 'asc',
  Desc = 'desc',
}
